import Alert from "./alert"
import Button from "./button"
import Drawer from "./drawer"
import Input from "./input"
import Link from "./link"
import Menu from "./menu"
import Modal from "./modal"
import NumberInput from "./number-input"
import Popover from "./popover"
import Select from "./select"
import Spinner from "./spinner"
import Stepper from "./stepper"
import Switch from "./switch"
import Table from "./table"
import Tabs from "./tabs"
import Tag from "./tag"
import Text from "./text"
import Textarea from "./textarea"
import Tooltip from "./tooltip"

const components = {
  Alert,
  Button,
  Input,
  Link,
  Menu,
  Modal,
  NumberInput,
  Select,
  Tag,
  Text,
  Textarea,
  Tooltip,
  Tabs,
  Switch,
  Popover,
  Drawer,
  Spinner,
  Table,
  Stepper,
}

export default components
